import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ds-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {

  isSearchOpen: boolean = false;
  isKeyPress:boolean=false;
  @Output() afterSearchOpen = new EventEmitter();

  constructor() { }

  searchOpen(val: string) {
    if (val) {
      this.isSearchOpen = true;
    } else {
      this.isSearchOpen = false;
    }
    this.afterSearchOpen.emit(this.isSearchOpen);
  }
  onFocusEvent()
  {   
    this.isKeyPress=true;    
  }
}
